import Bar from "../Components/Molecule/Bar";
import { useDispatch } from "react-redux";
import { setMenuShowing } from "../Redux/UserSlice";

type Props = {
  children: React.ReactNode;
  barAddOns?: React.ReactNode;
};

/**
   @function Layout
   render Layout for Pages
   @param {[React.Node]} children - Child components 
   @returns {React.Node}
*/
export default function Layout(props: Props) {
  const { children = [], barAddOns = [] } = props;
  const dispatch = useDispatch();

  return (
    <div className="overflow-hidden scroll-smooth relative">
      <div className="w-screen absolute z-40">
        <Bar onMenuClick={() => dispatch(setMenuShowing())}>{barAddOns}</Bar>
      </div>
      <div className="h-screen relative">{children}</div>
    </div>
  );
}
